import { render, staticRenderFns } from "./time-ago.vue?vue&type=template&id=a056e90a&scoped=true&"
import script from "./time-ago.vue?vue&type=script&lang=js&"
export * from "./time-ago.vue?vue&type=script&lang=js&"
import style0 from "./time-ago.vue?vue&type=style&index=0&id=a056e90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a056e90a",
  null
  
)

export default component.exports